module.exports = __webpack_public_path__ + "static/media/web-5.268946af.jpg";